<template>
  <!-- 主要内容的中间宽度 1370px -->
  <el-container
    style="width: 100%; height: auto; min-width: 1200px; min-height: 650px; background-color: white; padding: 0px; scrollbar-width: none;-ms-overflow-style: none;  ">
    <el-header height="175px" class="main-header" :style="{'position': isfixed}">
      <div>
        <div class="layout-container top-tips-container">
          <div class="content-container top-tips">
            <div>{{ $t("CommonObject.greeting")}}</div>
            <div>{{ $t("CommonObject.shopgreeting")}}</div>
            <div>
              <i18n_button></i18n_button>
            </div>
          </div>
        </div>
        <div class="layout-container top-logo-container">
          <div class="content-container">
            <div style="float: left; width: 50%;">
              <hsimage :src="logourl" style="height: 93px; width: 185px; float: left;"></hsimage>
              <!-- <div style="margin-top: 50px; float:left;">{{ $t("CommonObject.title")}}</div> -->
            </div>
            <div style="float: right; width: 50%; text-align: right;">
              
              <!-- facebook 按钮 -->
              <span style="float: right;">
                <a href="https://www.facebook.com/creativeknowledgelabs" target="_blank">
						      <hsimage style="cursor: pointer; width: 32px; height: 32px; margin-top: 4px; margin-left: 12px;" :src="facebook" @click="onClickFaceBook"></hsimage>
					      </a>
                  
                </span>
              <span style="float: right;">
                <div v-if="logined == false">
                  <el-button type="text" style="float: right; " @click="onClickQueryOrder"> {{ $t("LoginCommon.orderQuery") }}</el-button>
                  <el-button type="text" style="float: right; margin-right: 20px;" @click="onClickGoLogin"> {{ $t("LoginObject.name") }}</el-button>
                </div>
                <div v-else>
                  <div>
                    <el-popover placement="bottom" width="200" ref="AccountPopover" trigger="click">
                      <el-menu
                        @select="onItemClick"
                        @open="onMenuOpen"
                        v-if="defaultActive == ''"
                        :default-active="defaultActive"
                        active-text-color="#303133"
                        class="popover-menu"  
                        style="border: none;text-align: center;"
                        >
                        <el-menu-item 
                          v-for="item,index in tableData" :index="index.toString()" :key="index"
                          style="padding:0px; overflow: scroll;"
                          >
                            <!-- <i class="el-icon-s-custom"></i> -->
                            <span slot="title">{{item.name}}</span>
                        </el-menu-item>
                    </el-menu>
                      <el-avatar style="cursor: pointer;" size="large" slot="reference" :src="avatar">

                      </el-avatar>
                    </el-popover>
                  </div>
                </div>
                
              </span>
              <span style="float: right;"><Cart></Cart></span>
            </div>
          
              
              </div>
        </div>
        <div class="layout-container" style="width: 100%; background-color: #00A1FE;">
          <div class="content-container menu-none-border">
            <el-menu :default-active="activeIndex" class="el-menu-customer" mode="horizontal" @select="handleSelect">
              <el-menu-item index="mainpage"> {{ $t("HomeObject.name") }}</el-menu-item>
              
              <!-- <el-menu-item index="pointshop"> {{ $t("PointShopObject.name") }}</el-menu-item> -->
              <el-menu-item index="shoppingcenter">{{ $t("ShopObject.name") }}</el-menu-item>
              <el-menu-item index="reg">{{ $t('WarrantyObject.name') }}</el-menu-item>
              <el-menu-item index="freetrial"> {{ $t("FreetrialObject.name")}}</el-menu-item>
              <!-- <el-menu-item index="dictionarymain">{{ $t("DictionaryObject.name") }} </el-menu-item> -->
              <el-menu-item index="learnstar"> {{  $t("RankingObject.name") }}</el-menu-item>
              <el-menu-item index="">
                <el-popover
                  placement="bottom"
                  ref="GamePopover" 
                  trigger="hover">
                  <el-menu  
                    @select="onHelpItemClick"
                    style="border: none;text-align: center;">
                    <el-menu-item index="typingmain">
                      <span slot="title">{{ $t("TypingObject.name")}}</span>
                    </el-menu-item>
                    <el-menu-item index="dictionarymain">
                      <span slot="title">{{ $t("DictionaryObject.name")}}</span>
                    </el-menu-item>
                  </el-menu>
                  <div type="text" slot="reference">
                    {{ $t("GameCenterObject.name") }}</div>
                </el-popover>
              </el-menu-item>
              
              <el-menu-item index="about">{{ $t('AboutObject.name') }}</el-menu-item>
              <el-menu-item index="help">
               
                <el-popover
                  placement="bottom"
                  ref="HelpPopover" 
                  trigger="hover">
                  <el-menu  
                    @select="onHelpItemClick"
                    style="border: none;text-align: center;">
                    <el-menu-item index="contactUs">
                      <span slot="title">{{ $t('HelpObject.locateUs') }}</span>
                    </el-menu-item>
                    <el-menu-item index="faq">
                      <span slot="title">{{ $t('HelpObject.faq') }}</span>
                    </el-menu-item> 
                    <!-- <el-menu-item index="about">
                      <span slot="title">{{ $t('AboutObject.name') }}</span>
                    </el-menu-item>-->
                  </el-menu>
                  <div type="text" slot="reference">{{ $t('HelpObject.name') }}</div>
                </el-popover>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
    </el-header>
    <el-main style="padding: 0px;">
      <div class="main-content" :style="{'padding-top': content_top}">
        <el-container style="height: 100%; padding: 0px;">
          <el-main class="container-main">
            <div>
              <transition name="fade-right" mode="out-in">
              <keep-alive>
                <router-view>
                </router-view>
              </keep-alive>
            </transition>
            </div>
            <PageFooter></PageFooter>
          </el-main>
        </el-container>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import PageFooter from '@/components/common/page_footer.vue'
import Cart from '@/components/common/shoppingcart.vue'
import i18n_button from '../../components/common/i18n_button.vue'
import hsimage from '../../components/common/hsimage.vue'

export default {
  name: 'Main',
  components:{
    PageFooter,
    Cart,
    i18n_button,
    hsimage
  },
  data() {
    return {
      isfixed:'',
      isShow:true,
      content_top: '0px',
      logourl: require('../../../static/images/share/logo.png'),
      activeIndex: 'mainpage',
      logined: false,
      userInfo:{},
      avatar: '',
      facebook:require('../../../static/images/common/icon_fb.png'),
      tableData: [{
        index: '0',
        name: this.$t('AccountCenterObject.accountCenter') 
      }, 
      // {
      //   id: 'account_record',
      //   name: this.$t('AccountCenterObject.pointsRecord') ,
      //   index: '1'
      // }, 
      // {
      //   id: 'account_exchanged',
      //   name: this.$t('AccountCenterObject.exchangeRecord') ,
      //   index: '2'
      // },
      // {
      //   id: 'account_match',
      //   name: this.$t('AccountCenterObject.matchRecord') ,
      //   index: '3'
      // },
      {
        id: 'account_order',
        name: this.$t('AccountCenterObject.orderRecord') ,
        index: '1'
      },
      {
        id: 'logout',
        name: this.$t('AccountCenterObject.logout') ,
        index: '2'
      }
      ],
      defaultActive: '',
      isFromPromotion: false,
      isFromPayResult: false,
      isProductDetail: false,
      fromParmas:undefined,
      isFirstEnter: false

    }
  },
  activated() {
    this.$bus.$on('LOGIN_STATE_CHANGED',(check) =>{
      this.logined = check
    })
    this.initLoginInfo()
  },
  mounted() {
    window.addEventListener('scroll', this.initHeight);
    this.$bus.$on('LOGIN_STATE_CHANGED',(check) =>{
      this.logined = check
    })
    this.$bus.$on('LANGUAGE_CHEANGED',this.onLanguageChanged)
    this.initLoginInfo()
    this.$bus.$on('KEEP_ROUTE_STAY', (to,from) =>{
        // console.log('bus: on',to,from)
        this.onRouteChanged(from)
    })
    if(this.isFromPromotion){
      this.$router.push({name:'shoppingcar'})
      return
    }
    if(this.isFromPayResult){
      this.$router.push({ name: 'AccountCenter' ,params:{}})
      return 
    }
    if(this.isProductDetail){
      return
    }
    this.$router.push({ name: 'mainpage' })
  },
  beforeRouteEnter(to,from,next){
    next(vm=>{
      if(from.name == "detail"){
        vm.isFromPromotion = true
      }
      if(from.name == 'Callback'){
        // console.log("from.parmas",to)
        vm.isFromPayResult = true
        vm.fromParmas = to.params
      }
      if(to.name == 'productdetail'){
        vm.isProductDetail = true
      }
    })
  },
  beforeDestroy(){
    this.$bus.$off('KEEP_ROUTE_STAY')
    this.$bus.$off('LOGIN_STATE_CHANGED')
    this.$bus.$off('LANGUAGE_CHEANGED')
  },

  methods: {
    
    showBuyInfo(){
      // 
      // console.log('弹出提示框。。。。。')
      let url = 'www.sgcreativeknowledge.com'
      let urlstr = '<p style="color: blue;"><strong>'+url+'</strong></p>'
      var message = '<div>此网站正在建设中，购买请转到：<div>' + urlstr
      this.$confirm(message, '提示', {
        distinguishCancelAndClose: false,
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
        // showClose:false,
        type:'warning',
        confirmButtonClass:'confirm-button-class',
        cancelButtonClass:'cancel-button-class',
        confirmButtonText: '跳转',
        cancelButtonText: '取消',
      }).then(() => {
        window.open("http://"+url,'_blank')
      }).catch(() => {
        
      });
    },
    onMenuOpen(){
      this.onLanguageChanged(0)
    },
    onLanguageChanged(lang){
      this.tableData = [{
        index: '0',
        name: this.$t('AccountCenterObject.accountCenter') 
      }, 
      // {
      //   id: 'account_record',
      //   name: this.$t('AccountCenterObject.pointsRecord') ,
      //   index: '1'
      // }, 
      // {
      //   id: 'account_exchanged',
      //   name: this.$t('AccountCenterObject.exchangeRecord') ,
      //   index: '2'
      // },
      // {
      //   id: 'account_match',
      //   name: this.$t('AccountCenterObject.matchRecord') ,
      //   index: '3'
      // },
      {
        id: 'account_order',
        name: this.$t('AccountCenterObject.orderRecord') ,
        index: '1'
      },
      {
        id: 'logout',
        name: this.$t('AccountCenterObject.logout') ,
        index: '2'
      }
      ]
    },
    onHelpItemClick(val){
      // console.log("onHelpItemClick。。。",val)
      this.$router.push({ name: val })
      if (this.$refs.GamePopover != undefined) {
          this.$refs.GamePopover.doClose()
      }
      if (this.$refs.HelpPopover != undefined) {
          this.$refs.HelpPopover.doClose()
      }
      // if("about" == val){
      //   this.$router.push({ name: val })
      // }else if("faq" == val){

      // }else if("contactUs" == val){

      // }
    },
    initHeight() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // console.log('scrollTop:',scrollTop)
        if(scrollTop > 175){
          this.isfixed = 'fixed'
          this.content_top = '175px'
          this.isShow = false
        }else if(scrollTop > 0 && scrollTop <175){
                  
        }else if(scrollTop == 0){
          this.isfixed = ''
          this.content_top = '0px'          
          this.isShow = true  
        }
    },
    onRouteChanged(to){
      let parent = to.meta.parent
      if (parent != undefined) {
        this.activeIndex = parent
      } else {
        this.activeIndex = to.name
      }
    },
    initLoginInfo() {
      let userInfo = this.$store.state.userInfo
      this.userInfo = userInfo
      if (userInfo != undefined) {
        this.logined = true
        this.avatar = userInfo.avatar
      } else {
        var localUserInfo = this.$localStore.getUserInfo()
        if (localUserInfo != undefined) {
          this.$store.commit('saveUserInfo', localUserInfo)
          this.$store.commit('saveLoginToken', this.$localStore.getLoginToken())
          this.logined = true
        } else {
          this.logined = false
        }
      }
    },
    onPopoerShow(){
      this.defaultActive = ''
    },
    onClickFaceBook(){

    },
    onItemClick(index) {
      
      if (index != '2') {
        if (this.$refs.AccountPopover != undefined) {
          this.$refs.AccountPopover.doClose()
          this.$bus.$emit('Main_Account_Menu_changed',index)
          this.$router.push({ name: "AccountCenter", params: { type: index } }).catch(err => { })
        }
      } else {
        this.$alert(this.$t('AccountCenterObject.logoutTip'), this.$t('CommonObject.tipTitle'), {
            confirmButtonText: this.$t('CommonObject.exit'),
            confirmButtonClass: 'confirm-button-class',
            type:'warning',
            callback: action => {
              if('confirm' == action){
                // 清除登录信息
                this.$store.commit('saveUserInfo', undefined)
                this.$store.commit('saveLoginToken', '')
                this.$localStore.clearAll()
                this.$bus.$emit("LOGIN_STATE_CHANGED",false)
                this.logined = false
                // 不要跳转到登录页面的路由 2023-5-7
                // this.$router.push({ name: "Login", params: { type: 'login' } }).catch(err => {
                //   console.log(err)
                // })
              }
            }
        });
        
      }
    },
    
    onClickGoLogin() {
      this.$bus.$emit('OPEN_LOGIN_DIALOG')
      // this.$router.push({ name: "Login", params: { type: 'login' } }).catch(err => {
      //   console.log(err)
      //   console.log('跳转失败！')
      // })
    },

    onClickQueryOrder(){
      this.$router.push({ name: "OrderQuery"}).catch(err => {})
    },
    onClickRegist() {
      this.$router.push({ name: "Login", params: { type: 'regist' } }).catch(err => {
        // console.log(err)
        // console.log('跳转失败！')
      })
    },
    handleSelect(key, keyPath) {
      // console.log(key)
      this.$router.push({ name: key })
    },

    // 获取报名状态
    async getsignupMathStatus(val){
        let params =  {
            matchId: val.id,
            userId: this.userInfo.id
        }
        let response = await this.$request.postnotAuthor('/match/checkSignup',{},params,false)
        // console.log('response.',response)
        return response
      },
      signupMatch(val){
        let params =  {
            matchId: val.id,
            userId: this.userInfo.id
        }
        let game = val.game
        this.$request.postnotAuthor('/match/signup',{},params,false).then(response=>{
            if(response.data.code == 200){
              if(game == '1'){
                this.$set(val,'mode','match')
                this.$router.push({ name: 'PracticePage', params: val})
              }else if(game == '2'){
                this.$router.push({name:'DictionaryGame',params:{data:val}})
              }
            }else {
                this.$toastError(this.$t('CommonObject.fail'))
            }
        }).catch(err=>{
            // console.log('报名出错，请重试',err)
            this.$toastError(this.$t('CommonObject.fail'))
        })
      },
      // 点击弹框的去人
      onGoingMatchCheck(val){
        let game = val.game
        // 查询报名状态
        if(game == '1'){
          this.$set(val,'mode','match')
          this.$router.push({ name: 'PracticePage', params: val})
        }else if(game == '2'){
          this.$router.push({name:'DictionaryGame',params:{data:val}})
        }          
      }
  },
  watch: {
    '$route': { // $route可以用引号，也可以不用引号
          handler(to, from){
            if(from != undefined && from.params != undefined){
              let winlocation =  window.location.pathname
              // console.log("window:" + window.location.pathname)
              // console.log("from:", from.fullPath)
              if(!this.isFirstEnter && winlocation == '/index') {
                this.isFirstEnter = true;
                this.$router.push({ path: from.fullPath})
                return;
              }
              if(from.params.backData != undefined){
                let jsonStr = from.params.backData
                try {
                  let r = JSON.parse(jsonStr)
                  if(r != undefined){
                    // this.onRouteChanged(r)
                    // 如果是比赛中的界面，则跳到菜单页面
                    var pathName = r.name
                    if('DictionaryGame' == r.name || 'PracticePage' == r.name){
                      pathName = r.meta.parent
                    }
                    this.$router.push({ name:pathName})
                    // return
                  }
                }catch(e){}
              }
              // console.log('即将开始的比赛', from.params.goingMatch)
              // 即将开始的比赛
              if(from.params.goingMatch != undefined && from.params.goingMatch.length > 0){
                //
                let comingMatch = from.params.goingMatch[0]
                let title = comingMatch.title 
                let startTime = comingMatch.startTime
                let game = comingMatch.game
                let msg = title + '('+startTime+')' + '正在进行。'
                this.$confirm(msg+'，是否现在开始？', '温馨提示', {
                  distinguishCancelAndClose: false,
                  confirmButtonClass:'confirm-button-class',
                  cancelButtonClass:'cancel-button-class',
                  confirmButtonText: '开始比赛',
                  cancelButtonText: '稍后'
                })
                .then(() => {
                  this.onGoingMatchCheck(comingMatch)
                })
                .catch(action => {
                  
                });
                
              }
            }
            this.onRouteChanged(to)
            
          },
          deep: true, // 深度监听
          immediate: true, // 第一次初始化渲染就可以监听到
    },
    '$store.state.userInfo':{
      handler(newVal,Val){
			  // console.log('监听用户信息变化：',newVal);
        this.initLoginInfo()
		  },
      deep:true,
      immediate:true
    }
  }
}
</script>
<style src="../../../static/css/page_layout.css" scoped></style> 

<style scoped>
  /* 进入后和离开前保持原位 */
.fade-right-enter-to,
.fade-right-leave-from{
  opacity: 1;
}
 
 /* 设置进入和离开过程中的动画时长0.5s */
.fade-right-enter-active,
.fade-right-leave-active
{
  transition: all 0.5s;
}
 
 /* 进入前和离开后为透明，并在右侧20px位置 */
.fade-right-enter-from,
.fade-right-leave-to{
  opacity: 0;
  /* 原地消失 */
  transform: translateX(0px); 
}
</style>
<style scoped >
.top-tips-container {
  height: 40px;
  font-size: 16px;
  font-weight: bold;
  background-color: #C6EAFF;
}

.top-tips {
  color: black;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-none-border /deep/ .el-menu.el-menu--horizontal {
   border-bottom: none;
}
.menu-none-border /deep/ .el-menu-item {
  
  font-size: 18px;
  font-weight: 800;
}
.menu-none-border /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
  background-color: transparent;
  color:  white;
  /* font-weight: bold; */
  font-size: 18px;
  font-weight: 800;
}
.menu-none-border /deep/ .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none;
  /* font-weight: bold; */
  font-size: 18px;
  font-weight: 800;
}

.top-logo-container {
  height: 96px;
  background-color: white;

}


.main-header {
  padding: 0px;
  height: 173px;
  position: none;
  top: 0;
  width: 100%;
  z-index: 100;

}

.main-content {
  width: 100%;
  height: calc(100% - 4px);

  padding: 0px;
  /* min-height: calc(100% - 62px - 30px - 125px); */
  background-color: white;
}

.container-main {
  width: 100%;
  height: 100%;
  padding: 0px;
  display: block;
  justify-content: center;
  /* min-height: calc(100% - 62px - 30px - 125px); */
  background-color: white;
}

/* 修改原样式 */
.el-menu-customer {
  height: 50px !important;
  line-height: 50px !important;
  background-color: #00A1FE;
}

.el-menu-customer /deep/ .el-menu-item {
  height: 50px !important;
  border: none;
  line-height: 50px !important;
  color: #ffffff;
  opacity: 0.6;
}

.el-menu-customer /deep/ .el-menu-item.is-active {
  height: 50px !important;
  color: #FFFFFF;
  line-height: 50px !important;
  opacity: 1;
}

.el-menu-customer /deep/ .el-menu-item:focus {
  height: 50px !important;
  color: #FFFFFF;
  background-color: transparent;
  line-height: 50px !important;
}

.el-menu-customer /deep/ .el-menu-item:hover {
  height: 50px !important;
  background-color: transparent;
  color: #FFFFFF;
  line-height: 50px !important;
}
.el-main{
  overflow:visible !important;
}
.popover-menu /deep/ .el-menu-item{
  padding: 0px !important;
}
 

</style>


// WEBPACK FOOTER //
// src/views/hanscourse/Main.vue